<template>
    <div ref="modal" class="modal" tabindex="-1" role="dialog" id="modal-cali-filtro">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header" style="background:#196391;">
                    <h5 class="modal-title text-center white--text">Filtro de programas y modulos</h5>
                </div>
                <div class="modal-body text-center">
                    <v-row dense>
                        <v-col cols="12">
                            <v-combobox v-model="filtros.gestion" :items="gestiones" label="Gestion" :loading="loadinggestion" :disabled="loadinggestion" hide-details outlined dense></v-combobox>
                        </v-col>
                        <v-col cols="12">
                            <v-combobox v-model="filtros.programa" :items="programas" label="Programa" :loading="loadingprograms" :disabled="loadingprograms" hide-details outlined dense></v-combobox>
                        </v-col>
                        <v-col cols="12">
                            <v-combobox v-model="filtros.modulo" :items="modulos" label="Modulo" :loading="loadingmodulos" :disabled="loadingmodulos" hide-details outlined dense></v-combobox>
                        </v-col>
                    </v-row>
                </div>

                <div class="modal-footer">
                    <button @click="submit" v-if="activo" type="button" class="btn btn-azul white--text">Aceptar</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import gql from "graphql-tag";
export default {
    data() {
        return {
            activo: true,
            gestiones: [2018,2019,2020, 2021],
            programas: [],
            modulos: [],
            loadinggestion: false,
            loadingprograms: false,
            loadingmodulos: false,
            filtros: {
                gestion: null,
                programa: null,
                modulo: null,
            },
        };
    },
    watch: {
        'filtros.gestion': function(){
            if( this.filtros.gestion ) this.listarprogramasgraphql();
        }
    },
    components: {},
    methods: {
        open() {
            /* this.filtros.gestion = null;
            this.filtros.programa = null;
            this.filtros.modulo = null; */
            window.$("#modal-cali-filtro").modal("show");
        },
        async listarprogramasgraphql() {
            this.loadingprograms = true;
            this.loadingmodulos = true;
            this.programas = [];
            const vue = this;
            var sql = gql`query{ getProgramas(cursor:1000000,estado:true,idsede:1, gestion:${this.filtros.gestion}){ id,plataforma_id, course_category_id,fase,version,grupo,estado,codigo,nombre_compuesto} }`;
            await this.$apollo
                .query({ query: sql, variables: { cursor: this.cursor } })
                .then(({ data }) => {
                    let datos = data.getProgramas;
                    datos.forEach( (x,indice) => {
                        x.text = `${indice+1}.- ${x.nombre_compuesto}`;
                        x.value = x.id;
                        vue.programas.push(x);
                    })
                    //window.console.log(datos);
                    vue.loadingprograms = false;
                    vue.loadingmodulos = false;
                })
                .catch(() => {
                    vue.loadingprograms = false;
                    vue.loadingmodulos = false;
                });
        },
        submit() {
            this.$emit("listarcalificaciones", this.filtros);
        },
    },
};
</script>
